import React from 'react';
import { Box, Typography, Skeleton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Chip, Stack } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PushPinIcon from '@mui/icons-material/PushPin';
import moment from 'moment';
import { getFileDownloadLink } from '../../services/attachment.service';

const TYPE_CHIP_COLOR = { 1: 'info', 2: 'warning', 3: 'error' };

const AnnouncementDetail = ({ item, loading, intl }) => {
  const handleDownload = async (attachmentId) => {
    try {
      const res = await getFileDownloadLink(attachmentId);
      if (res?.data?.success && res.data.data) {
        window.open(res.data.data, '_blank');
      }
    } catch (e) {
    }
  };

  if (loading) {
    return (
      <Box>
        <Skeleton variant="text" height={40} sx={{ mb: 2 }} />
        <Skeleton variant="text" height={20} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={200} sx={{ mb: 2 }} />
      </Box>
    );
  }

  if (!item) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <Typography variant="body2" color="text.secondary">
          {intl.formatMessage({ id: 'noticeboard.detail.empty' })}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
        {item.title}
      </Typography>
      <Stack direction="row" spacing={1} sx={{ mb: 1, flexWrap: 'wrap' }}>
        <Chip
          size="small"
          color={TYPE_CHIP_COLOR[item.typeid] || 'info'}
          label={intl.formatMessage({ id: `noticeboard.type.${item.typeid || 1}` })}
        />
        {item.pinned && (
          <Chip size="small" variant="outlined" icon={<PushPinIcon />} label={intl.formatMessage({ id: 'noticeboard.card.pinned' })} />
        )}
        {item.requireacknowledgment && (
          <Chip size="small" variant="outlined" label={intl.formatMessage({ id: 'noticeboard.detail.requiresAcknowledgment' })} />
        )}
      </Stack>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {item.authorname || ''}
        {item.publishdate && (
          <>
            {' — '}
            {intl.formatMessage({ id: 'noticeboard.card.publishedAt' })}{' '}
            {moment(item.publishdate).format('DD/MM/YYYY HH:mm')}
          </>
        )}
      </Typography>

      {item.content && (
        <Box
          sx={{ mt: 2, mb: 3 }}
          dangerouslySetInnerHTML={{ __html: item.content }}
        />
      )}

      {item.attachments && item.attachments.length > 0 && (
        <Box sx={{ mt: 4 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
            {intl.formatMessage({ id: 'noticeboard.detail.attachments' })}
          </Typography>
          <List sx={{ p: 0 }}>
            {item.attachments.map((attachment) => (
              <ListItem key={attachment.attachmentid} disablePadding>
                <ListItemButton
                  onClick={() => handleDownload(attachment.attachmentid)}
                  sx={{ py: 0.75 }}
                >
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <FileDownloadIcon fontSize="small" sx={{ color: 'primary.main' }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={attachment.description}
                    secondary={attachment.size ? `${(attachment.size / 1024).toFixed(1)} KB` : ''}
                    primaryTypographyProps={{ variant: 'body2' }}
                    secondaryTypographyProps={{ variant: 'caption' }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
};

export default AnnouncementDetail;
